export default {

    getPaymentMethodImg(method, processor) {
        let image = "blank.png";
        if (method === 'card' || method === 'C') {
            image = "method_cards.png";
        }
        else if (method === 'payplug') {
            image = "method_payplug.svg";
        }
        else if (method === 'S') {
            if (processor === 'GP') {
                image = 'method_google.png';
            }
            else if (processor === 'apple'){
                image = 'method_apple.png';
            }
        }

        return require("@/assets/images/"+image);
    },

    formatReason(name)  {
        let result = "";
        switch (name) {
            case "flashMessage":
                result = "IB Accept";
                break;
            case "messageFlash":
                result = "IB Send";
                break;
            case "settings":
                result = "Account";
                break;
            case "sendLike":
                result = "Send Like";
                break;
            case "deleteLike":
                result = "Delete Like";
                break;
            case "profile":
                result = "Unlock Like";
                break;
            case "playVideoLike":
                result = "Unlock VideoLike";
                break;
            case "location":
                result = "Mode Travel";
                break;
            case "incognito":
                result = "Mode Incognito";
                break;
            default: result = name;
        }

        return result;
    },
}